"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const dateFormat = require("dateformat");
const fluxible_addons_react_1 = require("fluxible-addons-react");
const fluxible_router_1 = require("fluxible-router");
const BlogStore_1 = require("../stores/BlogStore");
const CommentForm_1 = require("./CommentForm");
const SideBar_1 = require("./SideBar");
const ApplicationStore_1 = require("../stores/ApplicationStore");
const gravatar = require("gravatar");
const react_loading_skeleton_1 = require("react-loading-skeleton");
const BlogActions_1 = require("../actions/BlogActions");
const clientDebug_1 = require("../clientDebug");
const react_helmet_1 = require("react-helmet");
class SinglePost extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        if (this.props.post && this.props.post.title) {
            (0, clientDebug_1.sendEvent)('GetBlogPostClient', { post: this.props.post.title });
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.post && this.props.post.title && this.props.post.textExtended !== prevProps.post.textExtended) {
            (0, clientDebug_1.sendEvent)('GetBlogPostClient', { post: this.props.post.title });
        }
    }
    componentWillUnmount() {
        this.props.unmountSinglePost();
    }
    render() {
        const post = this.props.post;
        const url = this.props.host + '/post/' + this.props.post.slug;
        const imageUrl = post.image != null ? post.image.secure_url : null;
        const description = post.textBrief.replace(/<[^>]+>/g, '');
        let title = `${this.props.post.title} - ${this.props.siteTitle}`;
        if (post.textBrief === 'loading') {
            title = 'Loading';
        }
        return (React.createElement("div", { className: "page-wrapper" },
            React.createElement(react_helmet_1.Helmet, null,
                React.createElement("title", null, title),
                imageUrl ? React.createElement("meta", { name: "twitter:card", content: "summary_large_image" }) :
                    React.createElement("meta", { name: "twitter:card", content: "summary" }),
                imageUrl && React.createElement("meta", { name: "og:image", content: imageUrl }),
                this.props.twitterName && React.createElement("meta", { name: "twitter:site", content: this.props.twitterName }),
                this.props.twitterName && React.createElement("meta", { name: "twitter:creator", content: this.props.twitterName }),
                React.createElement("meta", { property: "og:url", content: this.props.host + '/post/' + post.slug }),
                React.createElement("meta", { property: "og:title", content: title }),
                React.createElement("meta", { property: "og:type", content: "article" }),
                React.createElement("meta", { property: "og:description", content: description }),
                React.createElement("meta", { property: "description", content: description })),
            post.textBrief !== 'loading' ? (post.image && post.image.secure_url ?
                React.createElement("div", { className: "blog-post-main-image" },
                    React.createElement("img", { className: "post-image img-responsive", src: post.image.secure_url, alt: "blog-post-1" })) : null)
                : React.createElement("div", { className: "blog-post-main-image" },
                    React.createElement(react_loading_skeleton_1.default, { height: 400 })),
            React.createElement("div", { className: "blog-post-content" },
                React.createElement("h1", null, post.title),
                post.tags != null ?
                    React.createElement("ul", { className: "tags" }, post.tags.map((tag) => {
                        return (React.createElement("li", { key: tag },
                            React.createElement(fluxible_router_1.NavLink, { key: tag, href: '/blog?tag=' + tag }, tag)));
                    })) : null,
                post.textBrief !== 'loading' ?
                    React.createElement("div", { className: "post-entry", dangerouslySetInnerHTML: { __html: post.textExtended || post.textBrief } }) :
                    React.createElement(react_loading_skeleton_1.default, { count: 10 }),
                React.createElement("div", { className: "post-info" },
                    React.createElement("span", { className: "date" },
                        React.createElement("i", { className: "fa fa-fw fa-clock-o" }),
                        "Posted on ",
                        dateFormat(post.publishedDate, 'mmmm dS, yyyy')),
                    React.createElement("div", { className: "btn-group share-buttons pull-right hidden-xs" },
                        React.createElement("a", { target: "_blank", className: "btn", href: 'https://www.facebook.com/sharer/sharer.php?u=' + url + '=popup&ref=plugin&src=like&kid_directed_site=0' },
                            React.createElement("i", { className: "fa fa-facebook" })),
                        React.createElement("a", { target: "_blank", className: "btn", href: 'https://twitter.com/intent/tweet?text=' + post.title + ' - ' + url },
                            React.createElement("i", { className: "fa fa-twitter" })))),
                React.createElement("div", { className: "post-comments" },
                    React.createElement("div", { className: "block-title" },
                        React.createElement("h3", null,
                            "Comments (",
                            post.comments.length,
                            ")")),
                    post.comments.map((comment) => {
                        const gravatarUrl = gravatar.url(comment.author.email, {
                            protocol: 'https',
                            s: '80',
                        });
                        return (React.createElement("div", { className: "media", key: comment._id },
                            React.createElement("a", { className: "pull-left", href: "#" },
                                React.createElement("img", { className: "media-object", src: gravatarUrl, alt: "person" })),
                            React.createElement("div", { className: "media-body" },
                                React.createElement("div", { className: "media-heading" },
                                    React.createElement("a", { href: "#" }, comment.author.name),
                                    React.createElement("span", { className: "divider" }, "|"),
                                    React.createElement("span", { className: "light-gray" }, dateFormat(comment.publishedOn, 'HH:MM dd/mm/yyyy'))),
                                React.createElement("p", null, comment.content))));
                    })),
                React.createElement(CommentForm_1.default, { postComment: this.props.postComment, postId: post._id })),
            React.createElement(SideBar_1.default, null)));
    }
}
class SinglePostProps {
}
exports.default = (0, fluxible_router_1.handleHistory)((0, fluxible_addons_react_1.connectToStores)(SinglePost, [BlogStore_1.default], (context, props) => {
    return {
        post: context.getStore(BlogStore_1.default).getSinglePost(),
        host: context.getStore(ApplicationStore_1.default).getParam('host'),
        siteTitle: context.getStore(ApplicationStore_1.default).getParam('site_title') || 'xbim.dev',
        twitterName: context.getStore(ApplicationStore_1.default).getParam('twitter_name'),
        unmountSinglePost: () => context.executeAction(BlogActions_1.default.unmountSinglePost),
        postComment: (request) => context.executeAction(BlogActions_1.default.postComment, request),
    };
}));
